@if (isLoading) {
  <lib-loading-indicator [isLoading]="isLoading"></lib-loading-indicator>
}
<div class="projectable-form-wrapper frontdoor-form"
  (keyup.enter)="save($event)"
  (keyup.escape)="closeModal(false)"
>
  <lib-form-header
    [data]="formData"
    [title]="isExistingEntity ? 'View Authentication Provider: ' : 'Create New Authentication Provider'"
    [moreActions]="moreActions"
    (actionRequested)="headerActionRequested($event)"
    [(formView)]="formView"
  ></lib-form-header>
  <div class="integration-form-container projectable-form-container">
    @if (formView === 'simple') {
      <div class="auth-layout form-group-row">
        <div class="form-group-column full">
          <lib-form-field-container [title]="'Authentication Provider Details'">
            <div class="stacked-fields">

              <div class="field-row" [class.frontdoor-error-field]="nameError">
                <div class="field-label">
                  <span class="frontdoor-inline-error-group">
                    Name
                    <span class="err frontdoor-error-message frontdoor-label-error" [class.is-visible]="nameError">
                      {{ nameErrorMessage || 'Must not be blank' }}
                    </span>
                  </span>
                </div>
                <input placeholder="Name your provider." [(ngModel)]="formData.name" />
              </div>

              <div class="field-row" [class.frontdoor-error-field]="typeError">
                <div class="field-label">
                  <span class="frontdoor-inline-error-group">
                    Provider Type
                    <span class="err frontdoor-error-message frontdoor-label-error" [class.is-visible]="typeError">
                      {{ typeErrorMessage || 'Select a provider type' }}
                    </span>
                  </span>
                </div>
                <app-filter-select
                  [options]="providerTypes"
                  [(ngModel)]="formData.type"
                  placeholder="Select Type of Provider"
                  optionValue="type"
                  optionLabel="description"
                  (ngModelChange)="onTypeChange()"
                ></app-filter-select>
              </div>

              <div class="field-pair">
                <div class="field-row" [class.frontdoor-error-field]="clientIdError">
                  <div class="field-label">
                    <span class="frontdoor-inline-error-group">
                      Client ID
                      <span class="err frontdoor-error-message frontdoor-label-error" [class.is-visible]="clientIdError">
                        {{ clientIdErrorMessage || 'Enter a client ID' }}
                      </span>
                    </span>
                  </div>
                  <input placeholder="OAuth client id from your provider." [(ngModel)]="formData.data.client_id" />
                </div>
                <div class="field-row" [class.frontdoor-error-field]="clientSecretError">
                  <div class="field-label">
                    <span class="frontdoor-inline-error-group">
                      Client Secret
                      <span class="err frontdoor-error-message frontdoor-label-error" [class.is-visible]="clientSecretError">
                        {{ clientSecretErrorMessage || 'Enter a client secret' }}
                      </span>
                    </span>
                  </div>
                  <input placeholder="OAuth client secret from your provider." [(ngModel)]="formData.data.client_secret" />
                </div>
              </div>

              @if (formData.type === 'OIDC') {
                <div class="field-row" [class.frontdoor-error-field]="scopesError">
                  <div class="field-label">
                    <span class="frontdoor-inline-error-group">
                      Scopes
                      <span class="err frontdoor-error-message frontdoor-label-error" [class.is-visible]="scopesError">
                        {{ scopesErrorMessage || 'Enter at least one scope' }}
                      </span>
                    </span>
                  </div>
                  <app-chips-input
                    (keydown)="onKeyDown($event)"
                    [(ngModel)]="formData.data.scopes"
                    [allowDuplicate]="false"
                    [placeholder]="'Ex: openid, email'"
                    addOnBlur="true"
                    separator=","
                    (keyup.enter)="$event.stopPropagation()"
                    (keyup.space)="$event.stopPropagation()"
                  ></app-chips-input>
                </div>

                <div class="field-row" [class.frontdoor-error-field]="issuerError">
                  <div class="field-label">
                    <span class="frontdoor-inline-error-group">
                      Issuer
                      <span class="err frontdoor-error-message frontdoor-label-error" [class.is-visible]="issuerError">
                        {{ issuerErrorMessage || 'Enter an issuer URL' }}
                      </span>
                    </span>
                  </div>
                  <input placeholder="The OIDC issuer URL (used for auto-discovery)" [(ngModel)]="formData.data.issuer" />
                </div>

                <div class="field-row">
                  <div class="field-label">
                    Discovery URL
                    <span class="field-label-suffix">OPTIONAL</span>
                  </div>
                  <input placeholder="Add your discovery url." [(ngModel)]="formData.data.discovery_url" />
                </div>

                <div class="field-pair">
                  <div class="field-row" [class.frontdoor-error-field]="promptError">
                    <div class="field-label">
                      <span class="frontdoor-inline-error-group">
                        Prompt
                        <span class="err frontdoor-error-message frontdoor-label-error" [class.is-visible]="promptError">
                          {{ promptErrorMessage || 'Select a prompt' }}
                        </span>
                      </span>
                    </div>
                    <app-filter-select
                      [options]="promptTypes"
                      [(ngModel)]="formData.data.prompt"
                      placeholder="Select OIDC Prompt"
                      optionValue="value"
                      optionLabel="label"
                    ></app-filter-select>
                  </div>
                  <div class="field-row">
                    <div class="field-label">Supports PKCE</div>
                    <div class="switchGrid special">
                      <div (click)="toggleChecked()" [ngClass]="{ on: checked }" class="toggle">
                        <span [hidden]="!checked">ON&nbsp;&nbsp;&nbsp;</span>
                        <span [hidden]="checked">&nbsp;&nbsp;&nbsp;&nbsp;OFF</span>
                        <div class="switch"></div>
                      </div>
                    </div>
                  </div>
                </div>
              }

            </div>
          </lib-form-field-container>
        </div>
      </div>
    }
    @if (formView === 'raw') {
      <div class="form-group-column">
        @if (formData) {
          <lib-json-view [(data)]="formData"></lib-json-view>
        }
      </div>
    }
  </div>
</div>
